import AnalyticsEventName from './analyticsEventName';
import { ApdexTracker, initApdexEventListener } from './apdexEventService';
import { ApdexEventName } from './apdexEventsName';
import track from './track';
import initTrackSocialAuthLoginClick from './trackLogin';
import initTrackLogoutClick from './trackLogout';

/*
 * Necessary functionality in order to track login & logout clicks for all templates.
 * Currently calling these functions here is a necessary hack as there isn't a better
 * place where to call them. They should be moved when an opportunity comes.
 */
initTrackLogoutClick();
initTrackSocialAuthLoginClick();
initApdexEventListener();
export { track as default, AnalyticsEventName, ApdexEventName, ApdexTracker };
